import { render, staticRenderFns } from "./PharmaMap.vue?vue&type=template&id=7aaa7434&"
import script from "./PharmaMap.vue?vue&type=script&lang=js&"
export * from "./PharmaMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports